import { useState } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaRegCircleUser } from 'react-icons/fa6';
import { FiEye, FiEyeOff, FiLogIn } from 'react-icons/fi';
import './styles/auth.css';

// podmień na ścieżkę do zdjęcia kampusu (public/assets/...)
// np. wrzuć plik do public/assets/campus.jpg
import  CAMPUS_IMG from './assets/kampus_A.png';
import  ikona from './assets/icon.png';
import logo from "./assets/logo.png";

function LoginForm({ onLoginSuccess }) {
    const [login, setLogin] = useState('');
    const [haslo, setHaslo] = useState('');
    const [showPwd, setShowPwd] = useState(false);
    const [blad, setBlad] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const justRegistered = params.get('rejestracja') === 'true';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setBlad('');

        try {
            const response = await axios.post('/api/uzytkownicy/zaloguj', { login, haslo });
            const { token, uzytkownik } = response.data;
            localStorage.setItem('token', token);
            onLoginSuccess(uzytkownik);

            switch (uzytkownik.rola) {
                case 'admin': navigate('/admin'); break;
                case 'student': navigate('/student'); break;
                case 'prowadzacy': navigate('/prowadzacy'); break;
                default: navigate('/');
            }
        } catch (err) {
            setBlad(err.response?.data?.blad || 'Błąd logowania');
        }
    };

    return (
        <div
            className="auth-hero-bg"
            style={{ backgroundImage: `url("${CAMPUS_IMG}")` }}
            role="img"
            aria-label="Zdjęcie kampusu uczelni w tle"
        >
            {/* GLASS CARD */}
            <div className="auth-glass">
                <div className="auth-head">
                    <div className="auth-badge" aria-hidden>
                        <img src={ikona} alt="Logo" style={{ height: '80px', width: '64px' }} />
                    </div>
                    <div>
                        <h1 className="auth-title">Platforma Egzaminowania Elektronicznego GAMNS</h1>

                    </div>
                </div>

                <div className="auth-msg">
                    {justRegistered && (
                        <div className="auth-ok">
                            Rejestracja zakończona pomyślnie 🎉 Możesz się teraz zalogować.
                        </div>
                    )}
                    {!!blad && <div className="auth-err">{blad}</div>}
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="auth-field">
                        <label htmlFor="login" className="auth-label">Numer indeksu / adres e-mail</label>
                        <div className="auth-input-wrap">
                            <input
                                id="login"
                                className="auth-input"
                                type="text"
                                placeholder="Wpisz swój numer indeksu"
                                value={login}
                                onChange={(e) => setLogin(e.target.value)}
                                autoComplete="username"
                                required
                            />
                        </div>
                    </div>

                    <div className="auth-field">
                        <label htmlFor="haslo" className="auth-label">Hasło</label>
                        <div className="auth-input-wrap">
                            <input
                                id="haslo"
                                className="auth-input"
                                type={showPwd ? 'text' : 'password'}
                                placeholder="••••••••"
                                value={haslo}
                                onChange={(e) => setHaslo(e.target.value)}
                                autoComplete="current-password"
                                required
                            />
                            <button
                                type="button"
                                className="auth-eye"
                                onClick={() => setShowPwd(v => !v)}
                                aria-label={showPwd ? 'Ukryj hasło' : 'Pokaż hasło'}
                                title={showPwd ? 'Ukryj hasło' : 'Pokaż hasło'}
                            >
                                {showPwd ? <FiEyeOff size={18} /> : <FiEye size={18} />}
                            </button>
                        </div>
                    </div>

                    <div className="auth-row">
                        <label className="auth-remember">
                            <input type="checkbox" /> Zapamiętaj mnie
                        </label>
                        <button type="button" className="auth-link" onClick={() => navigate('/reset-hasla')}>
                            Zapomniałeś hasła?
                        </button>
                    </div>

                    <button type="submit" className="auth-cta">
                        <FiLogIn size={18} />
                        Zaloguj
                    </button>
                </form>

                <div className="auth-foot">
                    Nie masz konta?{' '}
                    <button className="auth-link" onClick={() => navigate('/rejestracja')}>
                        Zarejestruj się
                    </button>
                </div>
            </div>

            {/* Optional legal / caption */}
            <div className="auth-legal">
                © {new Date().getFullYear()} Gdańska Akademia Medyczna Nauk Stosowanych
            </div>
        </div>
    );
}

export default LoginForm;
